/* Cart drawer: open, close, quantity, and re-render after a change.
   Opens on sadil:cart-open, which the header bag and any add-to-cart
   dispatch, so nothing needs a direct reference to this file. */
(() => {
  'use strict';
  const root = document.querySelector('[data-sadil-cart]');
  if (!root) return;
  const drawer = root.querySelector('[data-cart-drawer]');
  const veil = root.querySelector('[data-cart-veil]');
  let lastFocused = null;

  const open = () => {
    lastFocused = document.activeElement;
    drawer.hidden = false; veil.hidden = false;
    requestAnimationFrame(() => { drawer.classList.add('is-open'); veil.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]')?.focus();
  };
  const close = () => {
    drawer.classList.remove('is-open'); veil.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; veil.hidden = true; }, 450);
    lastFocused?.focus();
  };

  document.addEventListener('sadil:cart-open', open);
  root.querySelectorAll('[data-cart-close]').forEach((b) => b.addEventListener('click', close));
  veil?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });
  if (sessionStorage.getItem('sadil:open-cart') === '1') {
    sessionStorage.removeItem('sadil:open-cart');
    open();
  }

  /* Quantity. Reload after Shopify updates the cart so the server renders
     the new line items, total and shipping message together. */
  const change = (key, qty) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        sessionStorage.setItem('sadil:open-cart', '1');
      })
      .then(() => window.location.reload());

  root.addEventListener('click', (e) => {
    const down = e.target.closest('[data-qty-down]');
    const up = e.target.closest('[data-qty-up]');
    if (!down && !up) return;
    e.preventDefault();
    const btn = down || up;
    const item = btn.closest('[data-cart-item]');
    const now = Number(item.querySelector('[data-qty]').textContent.trim()) || 0;
    change(btn.dataset.key, down ? Math.max(0, now - 1) : now + 1);
  });
})();
